import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { SalesPlanProducts } from 'components/BusinessToolForm/components/SalesPlanProducts';
import { GLOBAL_PRODUCTS_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { ISalesPlanProductVolumesProps } from './types';

export const SalesPlanProductVolumes: React.FC<ISalesPlanProductVolumesProps> = ({
  productsName: name,
  fields,
  disabled,
  onAddRow,
  onRemoveRow,
}) => {
  const { t } = useTranslation()
  return (
    <FormSectionCard
      disabled={disabled}
      title={t('marketingAndSales.sales.products.title')}
      collapsible
      aiFieldType="complex"
      aiFieldName={GLOBAL_PRODUCTS_NAME}
    >
      <SalesPlanProducts
        name={name}
        fields={fields}
        disabled={disabled}
        onAddRow={onAddRow}
        onRemoveRow={onRemoveRow}
      />
    </FormSectionCard>
  );
};
